// GENERATED from backend/services/billMemory/core — do not edit; run backend/scripts/sync-bill-memory-core.js
/**
 * Charge-like bill lines (source spec, "Learning on save"): a deleted freight, transport,
 * round-off, packing or delivery line teaches "not stock" for that vendor. Pure.
 */
import { makeMatchName } from './matchName';

const HEADS = new Set(['freight', 'transport', 'transportation', 'delivery', 'cartage', 'courier', 'hamali', 'loading', 'unloading', 'roundoff']);
const NEED_CHARGE = new Set(['packing', 'packaging', 'service', 'handling']);
const TAILS = new Set(['charge', 'cost', 'fee', 'amount']);

function isChargeLike(name) {
  const t = makeMatchName(name).split(' ').filter(Boolean);
  if (!t.length) return false;
  const joined = t.join(' ');
  if (joined === 'round off' || joined === 'packing' || joined === 'packaging') return true;
  const rest = t.slice(1);
  if (HEADS.has(t[0])) return rest.length === 0 || (rest.length === 1 && TAILS.has(rest[0]));
  if (NEED_CHARGE.has(t[0])) return rest.length === 1 && rest[0] === 'charge';
  return false;
}

export { isChargeLike };
